import { useLocation } from "react-router-dom";
import { Skeleton } from "antd";
import ProductCard from "../../components/cards/ProductCard";
import useFetchProducts from "../../hooks/useFetchProducts";
import { useTranslation } from "react-i18next";
import SearchBar from "./SearchBar.jsx";
import GoldenSpacing from "../Common/GoldenSpacing.jsx";

const SearchResults = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { products, loading } = useFetchProducts();

    const queryParams = new URLSearchParams(location.search);
    const searchText = queryParams.get("text")?.toLowerCase().trim() || "";

    const foundProducts = products.filter((product) =>
        product.name.toLowerCase().includes(searchText)
    );

    return (
        <div className="flex flex-col w-full">

            <div className="search-container flex justify-center items-center w-full pt-6">
                <div className="w-full max-w-[800px] px-4 sm:px-0 mx-auto">
                    <SearchBar />
                </div>
            </div>

            <GoldenSpacing
                referenceElementId="header"
                targetElementClass=".search-container"
            >
                <div className="w-full max-w-max mx-4  text-left">
                <h2 className="font-bold text-2xl mb-6">
                    {searchText ? `Результаты поиска: "${searchText}"` : "Поиск"}
                </h2>
                </div>
            </GoldenSpacing>

            {loading ? (
                <div className="flex justify-center items-center w-full">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                        {[...Array(10)].map((_, index) => (
                            <Skeleton.Node
                                key={index}
                                active
                                shape="square"
                                size="large"
                                style={{ width: "100%", height: "220px" }}
                            />
                        ))}
                    </div>
                </div>
            ) : foundProducts.length === 0 ? (
                <p className="text-gray-500 text-lg text-center">{t("noResultsWasFound")}</p>
            ) : (
                <div className="flex justify-center items-center w-full">
                    <div className="w-full px-4 pb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                        {foundProducts.map((product) => (
                            <div key={product.id} className="flex justify-center">
                                <ProductCard product={product} />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchResults;